import { MeshBasicMaterial, MeshPhongMaterial, MeshLambertMaterial } from 'three';

export const phantomMat = new MeshBasicMaterial({
  color: 0xffffff,
  opacity: 0.8,
  transparent: true,
});
export const newPhantomMat = new MeshPhongMaterial({
  color: 0xd0d0d0,
  opacity: 0.7,
  transparent: true,
});
export const whiteMat = new MeshLambertMaterial({ color: 0xc8c8c8, opacity: 0.1 });
export const whiteBody = new MeshLambertMaterial({ color: 0xc8c8c8 });
export const redMat = new MeshLambertMaterial({ color: 0xff0000 });
export const greenMat = new MeshLambertMaterial({ color: 0x00ff00 });
export const blueMat = new MeshLambertMaterial({ color: 0x0000ff });
export const yellowMat = new MeshBasicMaterial({ color: 0xffff00 });
export const plotnoMat = new MeshBasicMaterial({ color: 0xf0f3f3 });
export const plotnoMatInterior = new MeshBasicMaterial({ color: 0xf0f3f3 });
export const plotnoMatDark = new MeshBasicMaterial({ color: 0xc5c5c5 });
export const plotnoMatDarken = new MeshBasicMaterial({ color: 0xa0a0a0 });
export const sosnaMat = new MeshPhongMaterial({ color: 0xecd4b8 });
export const glassMat = new MeshLambertMaterial({
  color: 0xa0a0a0,
  transparent: true,
  opacity: 0.1,
});
export const edgeMat = new MeshPhongMaterial({ color: 0x606060, shininess: 100 });

export const frontMat = new MeshPhongMaterial({ color: 0xf0f0f0, shininess: 0.5 });

export const metals = {
  SRE: new MeshPhongMaterial({
    color: 0xc0c0c0,
    shininess: 50,
    specular: 0xd0d0d0,
  }),
  BRJ: new MeshPhongMaterial({
    color: 0xaf9c88,
    shininess: 50,
    specular: 0xffffff,
  }),
  SRAN: new MeshPhongMaterial({
    color: 0xc0c0c0,
    shininess: 50,
    specular: 0xd0d0d0,
  }),
  // 484846
  CA: new MeshPhongMaterial({
    // color: 0x484846,
    // shininess: 90,
    color: 0x020202,
    shininess: 80,
  }),
  CAM: new MeshPhongMaterial({
    color: 0x505050,
    shininess: 80,
  }),
  CAPM: new MeshPhongMaterial({
    color: 0x292929,
    shininess: 80,
  }),
  BR: new MeshPhongMaterial({
    color: 0xaf9c88,
    shininess: 50,
    specular: 0xffffff,
  }),
  STZL: new MeshPhongMaterial({
    color: 0xa89161,
    shininess: 50,
    specular: 0xffffff,
  }),
  ZL: new MeshPhongMaterial({
    color: 0xa7905e,
    shininess: 50,
    specular: 0x000000,
  }),
  ZLM: new MeshPhongMaterial({
    color: 0xaece96,
    shininess: 50,
    specular: 0xffffff,
  }),
  ZLSZ: new MeshPhongMaterial({
    color: 0xbcaa81,
    shininess: 50,
  }),
};

export const shadowMat = new MeshBasicMaterial({ transparent: true });
export const lightMat = new MeshBasicMaterial({ transparent: true });
export const lightMatExt = new MeshBasicMaterial({ transparent: true, depthTest: false });
export const lightstripeMat = new MeshBasicMaterial({ transparent: true, depthTest: false });

export const DAST = new MeshPhongMaterial({ color: 0xffffff });
export const DMON = new MeshPhongMaterial({ color: 0xffffff });
export const DSO = new MeshPhongMaterial({ color: 0xffffff });
export const DWO = new MeshPhongMaterial({ color: 0xffffff });
export const MSJ = new MeshPhongMaterial({ color: 0xffffff });
export const MSZ = new MeshPhongMaterial({ color: 0xffffff });
export const BI = new MeshPhongMaterial({ color: 0xffffff });
export const SZW = new MeshPhongMaterial({ color: 0xffffff });

export const BIP = new MeshBasicMaterial({
  color: 0xf0f0f0,
  reflectivity: 0.2,
});

export const BLP = new MeshBasicMaterial({
  color: 0xf0f0f0,
  reflectivity: 0.4,
});

export const CAP = new MeshBasicMaterial({
  color: 0x353535,
  reflectivity: 1,
});

export const JSZ = new MeshBasicMaterial({
  color: 0xd0d0d0,
  reflectivity: 0.3,
});

export const MAG = new MeshBasicMaterial({
  color: 0xdfd9d1,
  reflectivity: 0.4,
});

export const SZ = new MeshBasicMaterial({});

export const DASN = new MeshPhongMaterial({ color: 0xffffff });
export const DMU = new MeshPhongMaterial({ color: 0xffffff });
export const GF = new MeshPhongMaterial({ color: 0xffffff });
export const UKA = new MeshPhongMaterial({ color: 0xffffff });

export const bodyMaterials = {
  BI: BI,
  DMON: DMON,
  DSO: DSO,
  SZW: SZW,
};

export const texturedMaterials = {
  DAST: DAST,
  DMON: DMON,
  DSO: DSO,
  DWO: DWO,
  MSJ: MSJ,
  MSZ: MSZ,
  BI: BI,
  SZW: SZW,
  DASN: DASN,
  GF: GF,
  UKA: UKA,
  DMU: DMU,
};

export const mirrorMaterials = {
  BIP: BIP,
  BLP: BLP,
  CAP: CAP,
  JSZ: JSZ,
  MAG: MAG,
  SZ: SZ,
};

export let textures = {};
